// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"151":"576cc904","317":"576cc904"}[chunkId] + ".chunk.css";
};